export const CALENDAR_PAGE_LIMIT = 200;

// Match the dates displayed in the browser, including DST at month boundaries.
export const calendarMonthRange = (date) => ({
  start: new Date(date.getFullYear(), date.getMonth(), 1).toISOString(),
  end: new Date(date.getFullYear(), date.getMonth() + 1, 1).toISOString(),
});

export const calendarDayRange = (value) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) throw new Error("Jour invalide");
  const [year, month, day] = value.split("-").map(Number);
  const start = new Date(year, month - 1, day);
  if (start.getFullYear() !== year || start.getMonth() !== month - 1 || start.getDate() !== day) throw new Error("Jour invalide");
  return { start: start.toISOString(), end: new Date(year, month - 1, day + 1).toISOString() };
};

export const fetchCalendarPage = async (fetchPage, range, page, extra = {}) => {
  const start = +new Date(range.start);
  const end = +new Date(range.end);
  if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start ||
      end - start > 42 * 86400000 || !Number.isInteger(page) || page < 1) {
    throw new Error("Période ou page du calendrier invalide");
  }
  const response = await fetchPage({ ...extra, ...range, view: "calendar", page, limit: CALENDAR_PAGE_LIMIT });
  const result = response?.data;
  if (!Array.isArray(result?.data) || result.data.length > CALENDAR_PAGE_LIMIT ||
      result.currentPage !== page || !Number.isInteger(result.totalResults) || result.totalResults < 0 ||
      !Number.isInteger(result.totalPages) || result.totalPages < 0 || typeof result.hasMore !== "boolean" ||
      !Number.isInteger(result.limit) || result.limit < 1 || result.limit > CALENDAR_PAGE_LIMIT) {
    throw new Error("Réponse du calendrier non paginée ou invalide");
  }
  return { rows: result.data, currentPage: page, totalResults: result.totalResults,
    totalPages: result.totalPages, hasMore: result.hasMore,
    truncated: result.truncated === true, paginationLimitReached: result.paginationLimitReached === true };
};

export const appendCalendarPage = (previous, next) => {
  if (!previous) return next;
  const byId = new Map(previous.rows.map((row) => [String(row._id), row]));
  next.rows.forEach((row) => byId.set(String(row._id), row));
  return { ...next, rows: [...byId.values()] };
};

// Fetch only one bounded page per collection and only after explicit navigation.
export const fetchCalendarPages = async (loaders, range, previous = null) => {
  const streams = [
    ["scheduled", loaders.getScheduledCalls, {}],
    ["confirmed", loaders.getCrmLeads, { crmStatus: 1, isArchived: false }],
    ["nonConfirmed", loaders.getCrmLeads, { crmStatus: 2, isArchived: false }],
  ];
  const pages = await Promise.all(streams.map(async ([key, loader, extra]) => {
    const old = previous?.[key];
    if (old && !old.hasMore) return [key, old];
    const next = await fetchCalendarPage(loader, range, old ? old.currentPage + 1 : 1, extra);
    return [key, appendCalendarPage(old, next)];
  }));
  return Object.fromEntries(pages);
};
